import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon, BarsArrowUpIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import RefreshButton from "../../../components/RefreshButton";
import SearchButton from "../../../components/SearchButton";
import SelectInput from "../../../components/SelectInput";
import TextInput from "../../../components/TextInput";
import { useSFGetOffice } from "../OfficeSettings/hooks/useSFGetOffice";
import { searchData } from "./atoms/atoms";
import { useScorecardStatus } from "./hooks/useScorecardStatus";
import SelectInputVirtualize from "../../../components/SelectInputVirtualize";
import { useGetActionRequired } from "./hooks/useGetActionRequired";
const TableFilters = ({
  isSearching,
  setIsSearching,
  oldFilteredValue,
  setCaseNumberValue,
  setFilteredScorecard,
  setClearFilter,
  clearFilter,
  setReset,
  setIds,
  scoreCardLists,
  scoreCardDataList,
  searchClicked,
  employeeList,
  empLoading,
  setIsScorecardLoading,
}) => {
  const { data: agencies } = useSFGetOffice();
  const [, setStatus] = useState("");
  const [, setOfficeName] = useState("");
  const [, setCreatedBy] = useState("");
  const [, setCreatedDate] = useState("");
  const [caseNumbers, setCaseNumber] = useState("");
  const [, setAgentName] = useState("");
  const [, setActionOrRequired] = useState("");
  const [filteredScorecard, setFilteredData] = useState([]);
  const [searchInputsData, setSearchInputsData] = useRecoilState(searchData);

  useEffect(() => {
    if (clearFilter) {
      refreshScorecard();
    }
    setClearFilter(false);
  }, []);

  const sfOfficeNameOpt = agencies
    ?.filter(
      (value, index, self) =>
        self.findIndex((t) => t.officeName === value.officeName) === index
    )
    ?.map((x) => {
      return {
        name: x.businessOperation,
        id: x.officeCode,
        value: x.officeName,
        label: x.officeName,
      };
    });

  useEffect(() => {
    setIds(filteredScorecard && filteredScorecard?.map((x) => x.caseNumber));
  }, [filteredScorecard]);
  useEffect(() => {
    if (caseNumbers !== "") {
      setSearchInputsData({
        ...searchInputsData,
        CaseNumber: caseNumbers,
      });
      setIsScorecardLoading(true);
      searchClicked();
      setIsSearching(true);
    }
  }, [caseNumbers]);
  const refreshScorecard = () => {
    setIsSearching(false);
    setIds([]);
    setActionOrRequired("");
    setAgentName("");
    setCaseNumber("");
    setCreatedBy("");
    setCreatedDate("");
    setOfficeName("");
    setStatus("");
    setFilteredScorecard([]);
    setSearchInputsData({
      ...searchInputsData,
      Account: "",
      CaseNumber: "",
      Contact: "",
      CreatedBy: "",
      CreatedDate: "",
      Status: "",
      ActionRequiredOrNotificationC: "",
      ContactId: null,
      ActionReqOrNotifId: null,
      StatusId: null,
    });
    setReset(true);
  };
  const { data: statusScorecard } = useScorecardStatus();
  const statusOpts = statusScorecard?.data?.map((x) => {
    return {
      label: x.status,
      value: x.id,
    };
  });
  const { data: GetActionRequired } = useGetActionRequired();
  const actionRequiredOpts = GetActionRequired?.data?.map((x) => {
    return {
      id: x.id,
      value: x.actionReq,
      label: x.actionReq,
    };
  });

  useEffect(() => {
    if (setCaseNumberValue && isSearching) setCaseNumber(setCaseNumberValue);
  }, [isSearching, setCaseNumberValue]);
  return (
    <div className="pr-3 space-y-2 pt-2">
      <div class="pt-2">
        <BarsArrowUpIcon className="h-6 w-6 text-primary mb-1.5" />
        <div className="text-xl font-bold text-primary -mt-9 ml-8">
          Search Section
        </div>
      </div>
      <div className="w-full">
        <div className="w-full max-w-md mx-auto bg-white rounded-2xl">
          <Disclosure defaultOpen={isSearching}>
            {({ open }) => (
              <>
                <Disclosure.Button className="sm:px-2 flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                  <span>Scorecard Details</span>
                  <ChevronDownIcon
                    className={`${
                      open ? "transform rotate-180" : ""
                    } w-5 h-5 text-gray-500`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="bg-gray-100 text-sm text-primary rounded-b-lg">
                  <div className="bg-gray-100  p-3 sm:px-2 md:px-3">
                    <div className="flex flex-col text-xs gap-x-4 gap-y-2">
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Scorecard Number
                        </label>
                        <TextInput
                          name="caseNumber"
                          type="text"
                          value={
                            searchInputsData.CaseNumber
                              ? searchInputsData.CaseNumber
                              : caseNumbers
                          }
                          onChange={(e) => {
                            const inputValue = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                            setSearchInputsData({
                              ...searchInputsData,
                              CaseNumber: inputValue,
                            });
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Contact Name
                        </label>
                        <div className="w-full">
                          <SelectInputVirtualize
                            options={employeeList}
                            isLoading={empLoading}
                            onChange={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                Contact: e ? e.value : null,
                                ContactId: e ? e.id : null,
                              });
                            }}
                            value={employeeList?.filter(
                              (x) => x.label === searchInputsData.Contact
                            )}
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Created Date
                        </label>
                        <TextInput
                          name="createdDate"
                          type="date"
                          value={searchInputsData.CreatedDate}
                          onChange={(e) => {
                            setSearchInputsData({
                              ...searchInputsData,
                              CreatedDate: e ? e.target.value : null,
                            });
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Status
                        </label>
                        <div className="w-full">
                          <SelectInput
                            options={statusOpts}
                            onChange={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                StatusId: e ? e.value : null,
                              });
                            }}
                            value={statusOpts?.filter(
                              (x) => x.value === searchInputsData.StatusId
                            )}
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Owner
                        </label>
                        <TextInput
                          name="createdBy"
                          type="text"
                          value={
                            oldFilteredValue.CreatedBy
                              ? oldFilteredValue.CreatedBy
                              : searchInputsData.CreatedBy
                          }
                          onChange={(e) => {
                            setSearchInputsData({
                              ...searchInputsData,
                              CreatedBy: e ? e.target.value : null,
                            });
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Office Name
                        </label>
                        <div className="w-full">
                          <SelectInput
                            options={sfOfficeNameOpt}
                            onChange={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                Account: e ? e.value : null,
                              });
                            }}
                            value={sfOfficeNameOpt?.filter(
                              (x) => x.value === searchInputsData.Account
                            )}
                          />
                        </div>
                      </div>

                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Action Required or Notification Only
                        </label>
                        <SelectInput
                          options={actionRequiredOpts}
                          onChange={(e) => {
                            setSearchInputsData({
                              ...searchInputsData,
                              ActionRequiredOrNotificationC: e ? e.value : null,
                              ActionReqOrNotifId: e ? e.id : null,
                            });
                          }}
                          value={actionRequiredOpts?.filter(
                            (x) =>
                              x.value ===
                              searchInputsData.ActionRequiredOrNotificationC
                          )}
                        />
                      </div>
                      <div className="flex justify-center items-end gap-x-2 mb-12  lg:ml-4 md:ml-1 rounded-md mt-5">
                        <SearchButton
                          buttonValue="Search"
                          className={"opacity-100"}
                          onClick={() => {
                            setReset(false);
                            scoreCardDataList(scoreCardLists);
                            searchClicked();
                            setIsSearching(true);
                          }}
                        />
                        <RefreshButton
                          className={"opacity-100"}
                          disabled={false}
                          onClick={() => {
                            refreshScorecard();
                            searchClicked();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>{" "}
    </div>
  );
};

export default TableFilters;
